<template>
  <div class="addmana search" :style="noaddress ? {'background': '#fff'} : {}">
    <header>
      <form action="/">
        <van-search
          v-model="searchValue"
          placeholder="搜索"
          show-action
          clearable
          maxlength="32"
          @search="search"
          @cancel="cancel"
        />
      </form>
      <!--<span @click="cancel">取消</span>-->
    </header>
    <ul v-if="list && list.length > 0">
      <li v-for="(item, index) of list" :key="index">
        <p>
          <span>
            <b>{{item.name}}</b>
            <b>{{item.mobile}}</b>
          </span>
          <i @click="editor(item, index)">
            编辑
            <img src="../../assets/images/jt3.png">
          </i>
        </p>
        <p>
          {{(item.area +''+item.address).length > 40 ? (item.area +''+item.address).slice(0, 40) + '...' : item.area +''+item.address}}
        </p>
        <p>
          <b>
            <input :id="'checkbox'+index" type="radio" v-model="radio" :value="index" :checked='item.isChecked'  @click="check(item, index)">
            <label :for="'checkbox'+index">
              <i :class="{'on':item.isChecked}"></i>
              设为默认
            </label>
          </b>
          <b @click="deleteItem(item, index)">
            <img src="../../assets/images/delete.png">
          </b>
        </p>
      </li>
    </ul>
    <footer class="footerIOS" v-if="list && list.length > 0">
      <button class="btn" v-if="!!list && list.length < 50" @click="addClick">添加收货地址</button>
      <button class="btn btnGray" v-else-if="!!list && list.length >= 50">添加收货地址</button>
    </footer>
    <div v-if="noaddress" style="height: 100%;">
      <empty :path="'noAddress'"></empty>
    </div>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'addressManagement',
  data () {
    return {
      list: [],
      radio: [],
      gray: false,
      noaddress: false,
      searchValue: ''
    }
  },
  components: {
    empty
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'addressmanagement'})
    }
    this.getData()
    // 挂载完成后，判断浏览器是否支持popstate
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getAddressList_URL+'?keywords=' + this.searchValue
      var that = this
      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.list = res.data.addresslist
          if (that.list && that.list.length > 0) {
            that.noaddress = false
            that.list.map(item => {
              if (item.isdefault === '1') {
                item.isChecked = true
              } else {
                item.isChecked = false
              }
            })
          } else {
            that.noaddress = true
          }
        }
      })
    },
    goBack () {
      // 个人中心进入返回上一级，支付后进入返回首页
      if (this.$route.query.route) {
        this.$router.replace({path: '/'})
      } else {
        history.go(-1)
      }
    },
    check: function (items, index) {
      if (!this.list[index].isChecked) {
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          message: '正在提交...',
          forbidClick: true
        });
        // 先取消所有选中项
        this.list.forEach((item) => item.isChecked = false)
        // 再设置当前点击项选中
        // this.radio = this.list[index].value
        // 设置值，以供传递
        this.list[index].isChecked = true
        var url = this.$ajax.updateAddress_URL
        console.log(items)
        var data = {
          id: items.id,
          area: items.area,
          address: items.address,
          name: items.name,
          mobile: items.mobile,
          isdefault: '1',
          addressid: ''
        }
        var that = this
        that.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            that.$toast('信息已成功修改')
            that.list.map((item, idx) => {
              if (idx == index) {
                item.isdefault = 1
              } else {
                item.isdefault = 0
              }
            })
          }
        })
      }
    },
    editor: function (listItem, idx) {
      var urlOldAdd = this.$ajax.getAddressById_URL+'?id=' + listItem.id
      var that = this
      that.$customRequestAjax(urlOldAdd).then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('ckys4-editor-adress-management', JSON.stringify(res.data.addressdata))
          that.$router.push({path: '/editadd',
            query: {
              type: 'admin',
              id: listItem.id
            }
          })
        } else if (res.data.code == 500) {
          that.list.splice(idx, 1)
        }
      })

    },
    addClick: function () {
      this.$router.push({path: '/addadd',
        query: {
          type: 'admin'
        }
      })
    },
    deleteItem (items, idx) {
      if (items.isdefault == 1) {
        this.$toast('默认地址不能删除')
        return
      }
      var url = this.$ajax.deleteAddress_URL
      var data = {
        id: items.id
      }
      var that = this
      that.$dialog.confirm({
        message: '确认删除该地址？',
        className: 'collect_button_alert',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC',
        closeOnPopstate: true
      }).then(function () {
        // on confirm
        that.$toast.loading({
          mask: true,
          message: '正在提交...'
        })
        that.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            that.$toast('删除成功')
            that.list.splice(idx, 1)
            if (that.list && that.list.length <= 0) {
              that.noaddress = true
            } else {
              that.noaddress = false
            }
          } else if (res.data.code === 500) {
            that.list.splice(idx, 1)
            if (that.list && that.list.length <= 0) {
              that.noaddress = true
            } else {
              that.noaddress = false
            }
          }
        })
      }).catch(function () {
        // on cancel
      })
    },
    search: function () {
      this.getData()
    },
    cancel: function () {
      if (sessionStorage.getItem('order_history_num') == 3) {
        this.$router.go(-3)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  i {
    font-style: normal;
  }
  .addmana ul li p {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -webkit-flex;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -webkit-align-items: center;
  }
.addmana {
  header {
    padding-left: 0.1rem;
    background: #fff;
  }
  ul {
    margin-bottom: 0.73rem;
    li {
      background: #fff;
      padding: 0.16rem 0.12rem 0.07rem 0.16rem;
      margin-top: 0.1rem;
      p:first-of-type {
        span {
          b {
            float: left;
            font-size: 0.16rem;
            color: #222222;
            font-weight: 500;
            margin-right: 0.19rem;
          }
        }
        i {
          font-size: 0.12rem;
          color: #1D1E1E;
          img {
            float: right;
            width: 0.1rem;
            height: 0.1rem;
            padding:0 0.02rem 0;
            margin-top: 0.04rem;
          }
        }
      }
      p:nth-of-type(2) {
        font-size: 0.12rem;
        color: #999;
        height: 0.34rem;
        margin: 0.04rem 0 0.07rem;
      }
      p:last-of-type{
        padding-top: 0.08rem;
        border-top: 1px solid #EFEFEF;
        b:first-of-type {
          font-weight: 400;
          position: relative;
          i {
            display: block;
            width: 0.2rem;
            height: 0.2rem;
            float: left;
            margin-right: 0.08rem;
            background: url(../../assets/images/uncheck.png) no-repeat left top;
            background-size: 100% 100%;
          }
          input {
            display: block;
            float: left;
            position: absolute;
            width: 0.2rem;
            height: 0.2rem;
            left: 0;
            outline: none;
            -webkit-appearance: none;
            opacity: 0;
          }
          .on {
            background: url(../../assets/images/check.png) no-repeat left top;
            background-size: 100% 100%;
          }
          label {
            float: left;
            font-size: 0.12rem;
            color: #444;
            line-height: 0.2rem;
          }
        }
        b:last-of-type {
          img {
            width: 0.25rem;
            height: 0.25rem;
          }
        }
      }
    }
  }
}
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.1rem 0.11rem;
    background: #fff;
    .btn {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color:#FFFFFF;
      width: 100%;
      height: 0.43rem;
      margin-bottom: 0.1rem;
      background:linear-gradient(90deg,#FC0324,#F63A66);
      background: -webkit-linear-gradient(90deg,#FC0324,#F63A66);
      background: -o-linear-gradient(90deg,#FC0324,#F63A66);
      background: -moz-linear-gradient(90deg,#FC0324,#F63A66);
      background: -ms-linear-gradient(90deg,#FC0324,#F63A66);
    }
    .btn.btnGray{
      background: #DDDDDD;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/addressManagement.vue